import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Homepage from './components/Homepage'
import Contact from './components/Contact'
import Pricing from './components/Pricing'
import Youtube from './components/Youtube'
import RedirectURL from './components/RedirectURL'
import Profile from './components/Profile';
import Terms from './components/Terms';
import Policy from './components/Policy';
import { useEffect, useState } from 'react';


function App() {
  const [usd, setUsd] = useState(0)
  const [inr, setInr] = useState(0)
  const server = process.env.REACT_APP_SERVER //'http://localhost:8000'
  useEffect(() => {
    fetch('https://api.freecurrencyapi.com/v1/latest?apikey=' + process.env.REACT_APP_CURRENCY_API_KEY).then(res => res.json()).then(data => setUsd(data.data.INR))

    fetch(server + '/price', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(res => res.json()).then(data => setInr(data.price))
    //eslint-disable-next-line
  }, [])
  console.log(inr)


  return (
    <div >
      <Router>
        <Routes >
          <Route path="/" element={<Homepage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pricing" element={<Pricing usd={usd} inr={inr} server={server} />} />
          <Route path="/youtube" element={<Youtube server={server} />} />
          <Route path="/profile" element={<Profile server={server} />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/policy" element={<Policy />} />
          {/* redirecting page to generated url */}

          <Route path="/id/:url" element={<RedirectURL server={server} />} />
          <Route path="*" element={(<>
            Page not found
          </>)} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
